import { render, staticRenderFns } from "./ViewVar.vue?vue&type=template&id=1796a4d2&scoped=true&"
import script from "./ViewVar.vue?vue&type=script&lang=js&"
export * from "./ViewVar.vue?vue&type=script&lang=js&"
import style0 from "./ViewVar.vue?vue&type=style&index=0&id=1796a4d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1796a4d2",
  null
  
)

export default component.exports